import $ from 'jquery';

import { $Elements, Classes, Elements, Events } from '../global/constants';
import { ajax } from '../global/helpers';

$Elements.document.on(Events.page.enter, () => {

	// ---------- Ajax Posts ----------

	if(typeof ajax_posts_params !== 'undefined') {

		function initForm(form) {

			const searchPostTypes = ['post', 'folders', 'guide'];
			const page = form.find('input[name=page]');
			const button = form.find('button.ajax-posts-btn');
			const newSearch = form.find('button.new-search');
			const content = form.find('.ajax-content');
			const noResults = form.find('.no-results');
			const resetButton = form.find('.actions button[type=reset]');
			const countWrapper = form.find('.actions .count');
			const count = form.find('.actions .count .total');
			const searchCount = form.find('.ajax-search-filters');

			button.on('click', () => form.data('append', true));

			newSearch.on('click', () => refreshPosts(form));

			resetButton.on('click', () => refreshPosts(form, true));

			form.on('submit', async e => {
				e.preventDefault();
				e.stopImmediatePropagation();
				e.stopPropagation();

				button.attr('disabled', true);
				Elements.LoadingBar.classList.add(Classes.loading);

				const formData = new FormData(form[0]);
				formData.append('action', ajax_posts_params.action);

				try {
					const response = await ajax({
						url: ajax_posts_params.admin_url,
						type: 'POST',
						dataType: 'json',
						data: formData,
						processData: false,
						contentType: false,
					});

					if(response.data.content) {

						noResults.addClass(Classes.hidden);

						if(!form.data('append')) {
							content.empty();
						}

						content.append($(response.data.content));
						content.removeClass(Classes.hidden);
						count.text(response.data.found_posts);
						countWrapper.removeClass(Classes.hidden);
						searchCount.removeClass(Classes.hidden);

						if(searchCount.length > 0) {
							searchPostTypes.forEach(item => $('.count-' + item).html('<span>' + response.data.search_post_type_results[item] + '</span>'));
						}
					}
					else {
						content.addClass(Classes.hidden);
						noResults.removeClass(Classes.hidden);
					}

					if(response.data.next_page === 0) {
						button.addClass(Classes.hidden);
						button.attr('disabled', true);

						count.text(response.data.found_posts);
						countWrapper.removeClass(Classes.hidden);

						if(searchCount.length > 0) {
							searchCount.removeClass(Classes.hidden);
						}
					}
					else {
						count.text(response.data.found_posts);
						countWrapper.removeClass(Classes.hidden);
						page.val(response.data.next_page);
						button.removeClass(Classes.hidden);

						if(searchCount.length > 0) {
							searchCount.removeClass(Classes.hidden);
						}
					}
				}
				catch(e) {
					content.addClass(Classes.hidden);
					noResults.removeClass(Classes.hidden);
				}

				button.attr('disabled', false);
				Elements.LoadingBar.classList.remove(Classes.loading);

				return false;
			});
		}

		function refreshPosts(form, reset = false) {

			const page = form.find('input[name=page]');

			if(reset) {
				const filters = form.find('input[type=checkbox], input[type=radio], select');
				filters.prop('checked', false);
				form.find('input[name=search]').val('');
			}

			form.data('append', false);
			page.val(1);
			form.submit();
		}

		// --------- AJAX Search -----------
		$('form.ajax-posts-form-search').each(function() {

			initForm($(this));

			$Elements.document.on(Events.page.loaded, () => {
				refreshPosts($(this));
			});

		});

		$(document).ready(function() {
			const urlParams = new URLSearchParams(window.location.search);
			const category = urlParams.get('cat');

			if(category) {
				const filterSelector = `.ajax-posts-filter[value="${category}"]`;
				const filter = $(filterSelector);

				if(filter.length) {
					filter.prop('checked', true).trigger('change');
				}
			}
		});

		// --------- AJAX Filters -----------
		$('form.ajax-posts-form').each(function() {
			const form = $(this);
			const button = form.find('button[type=submit]');
			const page = form.find('input[name=page]');
			const filters = form.find('.ajax-posts-filter');
			const content = form.find('.ajax-posts');
			const noResults = form.find('.no-results');
			const thematique = document.getElementById('ajaxPosts').dataset.thematique;
			let filterActiveValue = 'all';

			button.on('click', () => {
				form.data('append', true);
				form.submit();
			});

			filters.on('change', (e) => {
				filterActiveValue = e.target.value;

				const label = $(e.currentTarget.parentNode);

				$('.ajax-posts-filters').find('label').removeClass('active');

				label.addClass('active');
				form.data('append', false);
				page.val(1);
				form.submit();
			});

			form.on('submit', async e => {
				e.preventDefault();
				e.stopImmediatePropagation();
				e.stopPropagation();

				button.attr('disabled', true);
				Elements.LoadingBar.classList.add(Classes.loading);

				const form_data = new FormData(form[0]);
				form_data.append('action', ajax_posts_params.action);

				if(filterActiveValue.length > 1 && filterActiveValue !== 'all' && thematique !== 'cabinet') {
					form_data.append('taxonomies[thematique]', filterActiveValue);
				}
				else if(thematique !== 'cabinet') {
					form_data.append('taxonomies[thematique]', thematique);
				}

				try {
					const response = await $.ajax({
						url: ajax_posts_params.admin_url,
						type: 'POST',
						dataType: 'json',
						data: form_data,
						processData: false,
						contentType: false,
					});

					if(response.data.content) {
						noResults.addClass(Classes.hidden);

						if(!form.data('append')) {
							content.empty();
						}

						content.append($(response.data.content));
						content.removeClass(Classes.hidden);
					}
					else {
						content.addClass(Classes.hidden);
						noResults.removeClass(Classes.hidden);
					}

					if(response.data.next_page === 0) {
						button.addClass(Classes.hidden);
						button.attr('disabled', true);
					}
					else {
						page.val(response.data.next_page);
						button.removeClass(Classes.hidden);
					}
				}
				catch(e) {
					content.addClass(Classes.hidden);
					noResults.removeClass(Classes.hidden);
				}

				button.attr('disabled', false);
				Elements.LoadingBar.classList.remove(Classes.loading);

				return false;
			});
		});

		// ---------- Clear Search Button ----------
		const input = document.querySelector('.form-control');
		const clearButton = document.getElementById('clearSearch');
		const form = $(input).closest('form');

		if(input && clearButton) {
			input.addEventListener('input', function() {
				if(input.value) {
					clearButton.classList.add('show');
				}
				else {
					clearButton.classList.remove('show');
				}
			});

			clearButton.addEventListener('click', function() {
				input.value = '';
				clearButton.classList.remove('show');
				refreshPosts(form, true);
			});
		}
	}
});
